import React, { useEffect } from 'react';
import './Download.css';
import AnimatedSection from '../AnimatedSection';

function Download() {
  // Device detection function
  const detectDevice = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
    const isAndroid = /android/i.test(userAgent);
    
    return { isIOS, isAndroid };
  };

  // Handle Android button click
  const handleAndroidClick = (e) => {
    e.preventDefault();
    window.open('https://play.google.com/store/apps/details?id=com.wesplit.app&hl=fr', '_blank', 'noopener,noreferrer');
  };

  // Handle iOS button click
  const handleIOSClick = (e) => {
    e.preventDefault();
    window.open('https://testflight.apple.com/join/g76Q5cTA', '_blank', 'noopener,noreferrer');
  };

  // Handle Solana DApp Store button click (same logic as dapp-store/index.html)
  const handleSolanaClick = (e) => {
    e.preventDefault();
    
    const dappStoreLink = 'solanadappstore://details?id=com.wesplit.app';
    const { isIOS, isAndroid } = detectDevice();
    
    // App detection using page visibility API
    let pageVisible = true;
    
    const handleBlur = () => {
      pageVisible = false;
    };
    
    const handleVisibilityChange = () => {
      if (document.hidden) {
        pageVisible = false;
      }
    };
    
    window.addEventListener('blur', handleBlur);
    document.addEventListener('visibilitychange', handleVisibilityChange);
    
    // Attempt to open DApp Store
    window.location.href = dappStoreLink;
    
    // Check after 1.5 seconds if DApp Store didn't open
    setTimeout(() => {
      window.removeEventListener('blur', handleBlur);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      
      if (pageVisible) {
        // DApp Store didn't open, redirect to appropriate store
        if (isIOS) {
          window.location.href = 'https://testflight.apple.com/join/g76Q5cTA';
        } else if (isAndroid) {
          window.location.href = 'https://play.google.com/store/apps/details?id=com.wesplit.app&hl=fr';
        } else {
          // Desktop: show both options
          window.open('https://testflight.apple.com/join/g76Q5cTA', '_blank', 'noopener,noreferrer');
        }
      }
    }, 1500);
  };

  return (
    <section className="download" id='download'>
      <div className="download-wrapper">
        <div className="download-bg">
       
        <div className="download-content">
          <AnimatedSection animationType="slide-left" stagger={1}>
            <h2 className="lp-section-title">Start Splitting <span className="lp-section-title-highlight">Today</span></h2>
            <p className="lp-section-subtitle">Start splitting crypto expenses with friends instantly, securely, and onchain.</p>
          </AnimatedSection>
          <AnimatedSection animationType="slide-up" stagger={2}>
            <div className="download-stores">
              <a href="https://play.google.com/store/apps/details?id=com.wesplit.app&hl=fr" onClick={handleAndroidClick} className="download-store-btn">
                <img src="https://firebasestorage.googleapis.com/v0/b/wesplit-35186.firebasestorage.app/o/website%2Fcta-android.png?alt=media&token=7c2a97bb-ac38-4975-85b8-03355554b648" alt="Get it on Google Play" />
              </a>
              <a href="https://testflight.apple.com/join/g76Q5cTA" onClick={handleIOSClick} className="download-store-btn">
                <img src="https://firebasestorage.googleapis.com/v0/b/wesplit-35186.firebasestorage.app/o/website%2Fcta-ios.png?alt=media&token=7343fec0-7aeb-4e2a-813f-4ecd72d2d7ac" alt="Download on App Store" />
              </a>
              <a href="solanadappstore://details?id=com.wesplit.app" onClick={handleSolanaClick} className="download-store-btn">
                <img src="https://firebasestorage.googleapis.com/v0/b/wesplit-35186.firebasestorage.app/o/website%2Fcta-solana.png?alt=media&token=5efc7252-ca98-44c3-8232-8b9ef7dd61f3" alt="dApp Store" />
              </a>
            </div>
          </AnimatedSection>
        </div>
        <AnimatedSection animationType="slide-right" stagger={1}>
          <div className="download-mockup">
            <img src="https://firebasestorage.googleapis.com/v0/b/wesplit-35186.firebasestorage.app/o/website%2Fcta-img.png?alt=media&token=d06d8294-eb32-4c76-a5a8-f529a5077a56" alt="WeSplit app mockup" className="download-mockup-img" />
          </div>
        </AnimatedSection>
        </div>
      </div>
    </section>
  );
}

export default Download; 